import { render } from "./Services3Section.vue?vue&type=template&id=326ef4b6&scoped=true"
import script from "./Services3Section.vue?vue&type=script&lang=js"
export * from "./Services3Section.vue?vue&type=script&lang=js"

import "./Services3Section.vue?vue&type=style&index=0&id=326ef4b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326ef4b6"]])

export default __exports__